import React from "react";
import { MessageCircleQuestion, Compass, Sparkles } from "lucide-react";
import type { ChatSuggestion } from "@/lib/chat/parseSuggestionsBlock";
import { cn } from "@/lib/utils";

interface FollowUpSuggestionsProps {
  suggestions: ChatSuggestion[];
  onSelect: (label: string) => void;
}

const ICONS = [
  { Icon: MessageCircleQuestion, color: "group-hover/suggestion:text-[#9333EA]" },
  { Icon: Compass, color: "group-hover/suggestion:text-blue-500" },
  { Icon: Sparkles, color: "group-hover/suggestion:text-amber-500" },
];

export const FollowUpSuggestions: React.FC<FollowUpSuggestionsProps> = ({
  suggestions,
  onSelect,
}) => {
  if (!suggestions.length) return null;

  return (
    <div className="mb-4 mt-1 flex flex-col">
      {suggestions.map((s, idx) => {
        const { Icon, color } = ICONS[idx % ICONS.length];
        return (
          <button
            key={`${s.label}-${idx}`}
            type="button"
            onClick={() => onSelect(s.label)}
            className={cn(
              "group/suggestion flex items-center gap-3 border-b border-primary/10 px-1 py-3 text-left",
              "first:border-t first:border-t-primary/10 last:border-b-0",
            )}
          >
            <span className="flex-shrink-0">
              <Icon
                className={cn(
                  "h-4 w-4 text-muted-foreground transition-colors",
                  color,
                )}
                aria-hidden="true"
              />
            </span>
            <span className="text-base leading-7 text-muted-foreground transition-colors group-hover/suggestion:text-primary">
              {s.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
